import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ROUTER_LIST from "./index";

const Created = () => {
    return <React.Suspense>
        <Router>
          <Routes>
            {ROUTER_LIST?.map((item, index) => {
                return <Route key={index} path={item.path} element={item.element} />
            })}
          </Routes>
        </Router>
      </React.Suspense>
}

export default Created